import { Menu } from '@headlessui/react';
import { observer } from 'mobx-react';
import { SearchParameter, SearchParameters } from '../../../../../ListFilter/Types';
import { NumberOption } from '../../../../Options/Types';
import { checkboxCondition, handleOnClick } from './SelectedOwner';

interface Props {
  updatingSearchParameters: (searchParameter: SearchParameter) => void;
  searchParameters: SearchParameters;
  option: NumberOption;
}

function MenuItem({ updatingSearchParameters, option, searchParameters }: Props) {
  return (
    <Menu.Item>
      {({ close }) => (
        <button
          onClick={handleOnClick(updatingSearchParameters, option, searchParameters)}
          className="flex w-full py-1"
        >
          <div className="flex flex-row bg-white text-gray-700 m-1 justify-between w-full">
            <div className="flex flex-row pr-6">
              <div className="pr-2">
                <div className="flex h-6 items-center">
                  <input
                    id="offers"
                    aria-describedby="offers-description"
                    name="offers"
                    type="checkbox"
                    className="h-4 w-4 rounded border-gray-300 text-teal-600 focus:ring-teal-600"
                    defaultChecked={checkboxCondition(option, searchParameters)}
                    onClick={close}
                  />
                </div>
              </div>
              <div className="text-sm">{option.label}</div>
            </div>
          </div>
        </button>
      )}
    </Menu.Item>
  );
}

export default observer(MenuItem);
